import Shepherd from 'shepherd.js'
import {highlightElStep, clickElStep} from './tours.js'

export function welcomeTourHook(tour) {
  let steps =
    [
      highlightElStep(tour, "Welcome to Sophie's Legacy", "Thanks for joining our legacy. We'll quickly (< 1 minute) take you through this section of our app.", "#my-account", "bottom"),
      clickElStep(tour, "More Options", "In the app, you can click on banners like this to reveal a drop down menu providing more actions for the table.", ".target-org-open-settings", "bottom"),
      highlightElStep(tour, "Create a new team", "Teams are groups of people or a work organisation. You may want to create a new group for an event or to gather information (coming soon).", ".button-target-new-organisation", "bottom"),

      highlightElStep(tour, "Feedback", "You can provide us feedback to improve the application or report issues.", "#feedback-component", "bottom"),

      clickElStep(tour, "Other Pages", "Utilise our main menu to visit other pages. You can manage your settings, your team settings and your payment subscriptions.", "#menu-opener", "bottom"),
      clickElStep(tour, "Other Pages", "You can close the main menu here.", "#menu-closer", "bottom"),
      highlightElStep(tour, "All Done :)", "Thanks for your time and supporting Sophie's Legacy!", "#menu-closer", "bottom", true)
    ]

  tour.addSteps(steps);

  return {
    shouldRun() {
      return JSON.parse(this.el.dataset.should_run);
    },
    completeTour() {
      this.pushEvent("complete-welcome-tour", {})
    },
    startTour() {
      tour.start();
      this.pushEvent("start-welcome-tour", {})
    },
    mounted() {
      if (this.shouldRun()) {
        console.log("Starting Tour");
        this.startTour();
        tour.on("complete", _ => this.completeTour());
        tour.on("cancel", _ => this.completeTour());
      }
    }
  }
}

